export default [
	{
		path: "/memberships",
		name: "memberships",
		meta: {
			requiresAuth: true,
			section: "memberships"
		},
		component: () => import("@/views/memberships/Memberships")
	},
	{
		path: "/memberships/create",
		name: "MembershipCreate",
		meta: {
			requiresAuth: true,
			section: "memberships"
		},
		component: () => import("@/views/memberships/MembershipForm")
	},

	{
		path: "/memberships/:id/update",
		name: "MembershipUpdate",
		meta: {
			requiresAuth: true,
			section: "memberships"
		},
		component: () => import("@/views/memberships/MembershipForm")
	},
	{
		path: "/memberships/:id/:tab?",
		name: "MembershipDetail",
		meta: {
			requiresAuth: true,
			section: "memberships"
		},
		component: () => import("@/views/memberships/MembershipDetail")
	}
]
